import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { RootState } from '..';

import {
  uploadMediaApiThunk,
  uploadMultipleMediaApiThunk,
  getMediaApiThunk,
  listMediaApiThunk,
  deleteMediaApiThunk,
  clearAllApiStatus,
  listMediaByIdsApiThunk,
} from './mediaSlice';
import {
  DeleteMediaRequest,
  GetMediaRequest,
  ListMediaByIdsRequest,
  ListMediaRequest,
  UploadMediaRequest,
} from 'src/types/helios/Media';

export const useMedia = () => {
  const dispatch = useAppDispatch();
  const mediaList = useAppSelector((state: RootState) => state.media.mediaList);
  const currentMedia = useAppSelector((state: RootState) => state.media.currentMedia);
  const mediaIdsMap = useAppSelector((state: RootState) => state.media.mediaIdsMap);

  const uploadMediaApiStatus = useAppSelector(
    (state: RootState) => state.media.uploadMediaApiStatus,
  );
  const getMediaApiStatus = useAppSelector(
    (state: RootState) => state.media.getMediaApiStatus,
  );
  const listMediaApiStatus = useAppSelector(
    (state: RootState) => state.media.listMediaApiStatus,
  );
  const deleteMediaApiStatus = useAppSelector(
    (state: RootState) => state.media.deleteMediaApiStatus,
  );
  const listMediaByIdsApiStatus = useAppSelector(
    (state: RootState) => state.media.listMediaByIdsApiStatus,
  );

  const uploadMedia = useCallback(
    async (data: UploadMediaRequest) => {
      dispatch(uploadMediaApiThunk(data));
    },
    [dispatch],
  );

  const uploadMultipleMedia = useCallback(
    async (dataList: UploadMediaRequest[]) => {
      return dispatch(uploadMultipleMediaApiThunk(dataList));
    },
    [dispatch],
  );

  const getMedia = useCallback(
    async (data: GetMediaRequest) => {
      dispatch(getMediaApiThunk(data));
    },
    [dispatch],
  );

  const listMedia = useCallback(
    async (data: ListMediaRequest) => {
      dispatch(listMediaApiThunk(data));
    },
    [dispatch],
  );

  const listMediaByIds = useCallback(
    async (data: ListMediaByIdsRequest) => {
      dispatch(listMediaByIdsApiThunk(data));
    },
    [dispatch],
  );

  const deleteMedia = useCallback(
    async (data: DeleteMediaRequest) => {
      dispatch(deleteMediaApiThunk(data));
    },
    [dispatch],
  );

  const clearMediaAllApiStatus = useCallback(() => {
    dispatch(clearAllApiStatus());
  }, [dispatch]);

  return {
    mediaList,
    currentMedia,
    mediaIdsMap,
    uploadMedia,
    uploadMultipleMedia,
    getMedia,
    listMedia,
    deleteMedia,
    listMediaByIds,
    uploadMediaApiStatus,
    getMediaApiStatus,
    listMediaApiStatus,
    deleteMediaApiStatus,
    clearMediaAllApiStatus,
    listMediaByIdsApiStatus,
  };
};
